import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../_actions/alert.actions'
import { usersService } from '../../../../_services/users.service'
import { Alert, Button, Col, Modal, Row, Spinner } from 'react-bootstrap'

export default function InactivateModal({ user, show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    
    setTimeout(() => {
      handleClose(false)
    }, 100);
  }
  
  const handleInactivate = () => {
    setError('')
    setLoading(true)

    usersService.inactivateUser(user.userId)
      .then(() => {
        handleClose(true)
        dispatch(alertActions.success('User inactivated.'));
      })
      .catch(() => {
        setError('Could not inactivate user at this time. Please try again.');
      })
      .then(() => {
        setLoading(false)
      })
  }

  const name = user ? `${user.firstName} ${user.lastName}` : null;

  return (
    <Modal show={show} onHide={handleCloseModal} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Inactivate User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
             <p>{`By inactivating, ${name} will not be able to login, but the account and activity will be kept.`}</p>
             <p>Are you sure you want to inactivate?</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='4'>
            <Button disabled={loading} onClick={handleInactivate} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Yes, inactivate'}
            </Button>
          </Col>
          <Col xs='3'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>No, cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
